<div class="allfootcont">
        <!-- <div class="footwo visible-lg visible-md">
          <div class="clarot-title">
            <div class="container vcenter">
              <div class="tabcell">
                Empresas
              </div>
            </div>
          </div>

          <div class="basicrow m-top">
            <div class="container">
              <div class="row">
                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-left">
                  <span class="ftwo-title">M&oacute;vil</span>

                  <a class="ftwo-link" >Voz</a>

                  <a class="ftwo-link" >Servicio Inteligente</a>

                  <a class="ftwo-link" >Servicio de Rastreo</a>

                  <a class="ftwo-link" >Cobertura</a>
                </div>

                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-left">
                  <span class="ftwo-title">Internet</span>

                  <a class="ftwo-link" >Internet Dedicado</a>

                  <a class="ftwo-link" >Internet M&oacute;vil</a>
                </div>

                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-left">
                  <span class="ftwo-title">Datos</span>

                  <a class="ftwo-link" >EVLS</a>

                  <a class="ftwo-link" >IP MPLS</a>

                  <a class="ftwo-link" >L&iacute;neas Dedicadas</a>
                </div>

                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-left">
                  <span class="ftwo-title">Data Center</span>

                  <a class="ftwo-link" >Collocation</a>

                  <a class="ftwo-link" >Virtual Servers</a>
                </div>

                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-left">
                  <span class="ftwo-title">Telefon&iacute;a</span>

                  <a class="ftwo-link" >Servicio de Telefon&iacute;a</a>
                </div>

                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-left">
                  <span class="ftwo-title">Servicios Cloud</span>

                  <a class="ftwo-link" >Office 365</a>

                  <a class="ftwo-link" >Virtual Servers</a>

                  <a class="ftwo-link" >Cloud PBX</a>
                </div>
              </div>
            </div>
          </div>

          <div class="basicrow m-top">
            <div class="container">
              <div class="basicrow">
                <span class="ftwo-title">Redes Sociales</span>
              </div>

              <div class="basicrow">
                <a href="https://www.facebook.com/Claropr/" target="_blank" class="social-ls">
                  <i class="fa fa-facebook-square" aria-hidden="true"></i>
                </a>

                <a href="https://twitter.com/clarotodo?lang=es" target="_blank" class="social-ls">
                  <i class="fa fa-twitter-square" aria-hidden="true"></i>
                </a>

                <a href="https://www.instagram.com/claropr/" target="_blank" class="social-ls ig">
                  <i class="fa fa-instagram" aria-hidden="true"></i>
                </a>

                <a href="https://www.youtube.com/user/clarotodo/videos" target="_blank" class="social-ls">
                  <i class="fa fa-youtube-square" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>
        </div> -->

        <div class="footcont">
          <div class="container vcenter">
            <div class="tabcell">
              <div class="autorow pull-left full-c mob-text mob-width">
                <img width="100%" class="footlogo" src="../../../../assets/images/footlogo.png">Todos los derechos reservados, Claro 2024
              </div>

              <div class="autorow pull-right full-c mob-text">
                <a target="_blank" class="h-ref" href="https://www.claropr.com/portal/pr/legal-regulatorio/pdf/1662145685810-Archivo.pdf">Legal y Regulatorio</a>
              </div>
            </div>
          </div>
        </div>
      </div>
